import apiServices from '../../apiServices';
import {UPDATE_ACTIVATION_DATA} from '../actionTypes';
import {ActivationData} from './types';

const setActivationData = (activationData: ActivationData) => ({type: UPDATE_ACTIVATION_DATA, activationData});

export const requestUserState = (login: string) => async () => {
    const {data: userState, ok: isSuccess, status: statusCode} = await apiServices.checkStatus({login});

    return {userState, isSuccess, statusCode};
};

export const requestSignUp = (login: string) => async dispatch => {
    const {data: signUpInfo, ok: isSuccess} = await apiServices.signUp({login});

    if (signUpInfo?.success) {
        dispatch(setActivationData({active: signUpInfo.active}));
    }

    return {signUpInfo, isSuccess};
};
